import React, { Component } from 'react';
import { Form, withFormik } from 'formik';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';
import * as Yup from 'yup';
import {
  AvatarChooser,
  Input as FormInput,
  Dropdown as FormDropdown,
} from '../../Form/index';
import api from '../../../api/index';
import './ProfileCard.css';
import {
  withInputClassNames,
  withDropdownClassNames,
} from './../../EditProfile/HOC';
import { Regex } from '../../../shared/helpers';

const Input = withInputClassNames(FormInput);
const Dropdown = withDropdownClassNames(FormDropdown);

class ProfileCard extends Component {
  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.values, this.props.values)) {
      this.send();
    }
  }

  send = debounce(() => {
    const { values, errors } = this.props;
    this.props.handleInputChange({ values, errors });
  }, 300);

  render() {
    const { values } = this.props;
    return (
      <div className="col-12 col-lg-7 mx-auto">
        <div className="bg-white shadow-card p-5">
          <div className="row">
            <div className="col">
              <AvatarChooser
                name="avatar_url"
                label="Upload a profile photo"
                alt="Profile Picture"
                pictureClassName={`edit-profile__content-profile-pic ${values.picture &&
                  'edit-profile__content-profile-pic-with-border'}`}
                labelClassName="edit-profile__content-profile-pic-label profile-card__image-label mt-3"
              />
            </div>
          </div>
          <Form className="profile-card__form">
            <div className="form-row">
              <Input label="Name" name="name" className="form-control" />
            </div>
            <div className="form-row">
              <Input label="E-mail" name="email" className="form-control" />
              <Input
                label="Phone Number"
                name="phone_number"
                type="phoneNumber"
                inputClassName="form-control"
                placeholder="555-555-5555"
              />
            </div>
            <div className="form-row">
              <div className="col-12 col-lg-6">
                <Dropdown
                  fluid
                  enableSearch
                  search={api.fetchCountries}
                  noResultsMessage="No countries found."
                  label="Country"
                  name="country"
                  clearOnChange="state"
                  placeholder="Select a Country"
                  onChange={(field, form) => {
                    form.setFieldValue('state', undefined);
                  }}
                />
              </div>
              <div className="col-12 col-lg-6">
                <Dropdown
                  fluid
                  enableSearch
                  allowAdditions
                  search={query =>
                    api.fetchStates(query, values.country || 'United States')
                  }
                  noResultsMessage="No states found."
                  label="State"
                  name="state"
                  placeholder="Select a State"
                />
              </div>
            </div>
          </Form>
        </div>
      </div>
    );
  }
}

ProfileCard.propTypes = {
  values: PropTypes.object,
  errors: PropTypes.object,
  handleInputChange: PropTypes.func,
};

export default withFormik({
  enableReinitialize: true,
  validateOnBlur: true,
  validateOnChange: true,
  validationSchema: Yup.object().shape({
    name: Yup.string()
      // eslint-disable-next-line no-template-curly-in-string
      .min(4, 'Name should have at least ${min} characters')
      .required('Name is required')
      .test('is-full-name', 'Name is not a full name', value =>
        value.match(Regex.fullName),
      ),
    email: Yup.string().email(
      'Email is invalid, please fix your entry and try again',
    ),
  }),
  displayName: 'ProfileCardForm',
})(ProfileCard);



// WEBPACK FOOTER //
// ./src/components/FreelancerPortfolio/ProfileCard/ProfileCard.js